import { scopes } from '../scopes';
import { Policy } from '../Policy';
import { gates } from '../gates';
export class CreditsPolicy extends Policy {
  billingAccess() {
    return this.user.hasScope(scopes.BILLING_ACCESS);
  }

  /**
   * Check if the user can do a usage action
   * when ungated for HubSpot credits we will check
   * if free credits user has enough credits to do the action
   * @param action - The action to check
   * @returns true if the user can do the action, false otherwise
   */
  usageAction(action) {
    if (this.hubspotCredits()) {
      if (action === 'DATASET_ENRICHMENT' || action === 'INTENT_MONITORING' || action === 'SMART_PROPERTY_RUN') {
        var _this$record$creditAu, _this$record;
        return (_this$record$creditAu = (_this$record = this.record) === null || _this$record === void 0 || (_this$record = _this$record.creditAuthorization) === null || _this$record === void 0 ? void 0 : _this$record[action]) !== null && _this$record$creditAu !== void 0 ? _this$record$creditAu : false;
      }
      return false;
    }
    return true;
  }

  /**
   * Check if the user can do data enrichment
   */
  enrichData() {
    return this.usageAction('DATASET_ENRICHMENT');
  }

  /**
   * Check if the user can do intent monitoring
   */
  monitorIntent() {
    return this.usageAction('INTENT_MONITORING');
  }

  /**
   * Check if the user can do smart property run
   */
  runSmartProperty() {
    return this.usageAction('SMART_PROPERTY_RUN');
  }
  hubspotCredits() {
    return this.user.hasGate(gates.HUBSPOT_CREDITS);
  }
  includedEnrichment() {
    return this.user.hasCreditsPlan() && this.user.hasGate(gates.ENRICHMENT_INCLUDED);
  }
  platformAccess() {
    return this.user.hasScope(scopes.ENRICHMENT_PLATFORM_ACCESS);
  }
  viewCredits() {
    return this.platformAccess();
  }
}